import { YooKassaPaymentWithEmail } from './YooKassaPaymentWithEmail.main';

export { YooKassaPaymentWithEmail };
